<template>
  <div>
    <div class="question-text" role="heading" aria-level="3" v-html="question.questionText"></div>
    <div class="question-description" v-html="question.questionDescription"></div>
    <textarea
      v-if="isFreeText"
      class="w-full h-[100px] mt-12 p-4 rounded-xl"
      :placeholder="placeholder"
      :aria-label="inputLabel"
      v-model="answer"
    />
    <input
      v-if="isNumber"
      type="number"
      class="w-[200px] p-4 rounded-xl"
      min="0"
      v-model="answer"
      :placeholder="placeholder"
      :aria-label="inputLabel"
    />
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import poster from "../../mixins/poster";
import { FreeTextQuestion } from "@/Consultation/types";
import responseAdapters from "@/Consultation/mixins/responseAdapters";

export default Vue.extend({
  mixins: [poster],
  inject: ["submitUrl", "csrfHeader", "csrf"],
  props: {
    question: {
      required: true,
      type: Object as PropType<FreeTextQuestion>,
    },
    showRequired: { required: true },
  },
  data() {
    const defaultLabel = this.question.freeTextType === "FREE_TEXT" ? "Free text input" : "Free number input";
    return {
      answer: this.question.response,
      placeholder: this.question.placeholder || "",
      inputLabel: this.question.placeholder || defaultLabel,
      isFreeText: this.question.freeTextType === "FREE_TEXT",
      isNumber: this.question.freeTextType === "NUMBER",
      responseAdapter: responseAdapters.freeText,
    };
  },
  created() {
    this.updateNextButton();
    this.$emit("answer", this.question);
  },
  computed: {
    isComplete: function () {
      if (!this.isNumber) return true;

      // Given the number input as string (as the expected type to the Java backend)
      // validate the string is of a valid number.
      return /^[0-9]+([.][0-9]+)?$/.test(this.answer);
    },
  },
  watch: {
    answer: function (val) {
      // eslint-disable-next-line vue/no-mutating-props
      this.question.response = val;
      this.post(this.responseAdapter(this.question));
      this.updateNextButton();
      this.$emit("answer", this.question);
    },
  },
  methods: {
    updateNextButton() {
      this.$emit("update-next-button-status", this.isComplete);
    },
  },
});
</script>
